import { log } from '../tracking/InternalLogger';
import { detectFormTest } from '../helpers/detect-form-test';
const currentDomain = window.location.hostname;
const customerReferralResultCallback = (callbackData) => {
    log('Form submit result', {
        formName: 'Customer referral',
        status: callbackData.xhr.status,
        isTest: detectFormTest(callbackData.data),
    });
    const isSuccess = callbackData.xhr.status >= 200 && callbackData.xhr.status < 300;
    const referralCode = callbackData.formContainer.querySelector('.customer-referral-form .referral-code-url');
    if (isSuccess &&
        referralCode &&
        typeof callbackData.xhr.response === 'object' &&
        typeof callbackData.xhr.response.code === 'string') {
        referralCode.innerHTML = `https://${currentDomain}${window.pageUrls.useRecommendation || '/ich-bin-dabei'}?referralID=${callbackData.xhr.response.code}`;
    }
    return true;
};
export const customerReferralCallbacks = {
    customerReferralResultCallback,
};
